import { useId, useState, type Ref } from "react";
import { t } from "../../i18n";

interface Props {
  ref: Ref<HTMLInputElement>;
  /** Enter: the typed code ("2DP", "PEPM", "CC"); the field empties for the next one. */
  onCode: (code: string) => void;
}

/** "Code F3" above the menu (prototype codebox): type a product code and press Enter. */
export function CodeBox({ ref, onCode }: Props) {
  const id = useId();
  const [value, setValue] = useState("");
  return (
    <div className="codebox">
      <label htmlFor={id}>
        {t.sale.code} <span className="code">F3</span>
      </label>
      <input
        id={id}
        ref={ref}
        value={value}
        placeholder={t.sale.codePlaceholder}
        autoComplete="off"
        spellCheck={false}
        onChange={(event) => {
          setValue(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key !== "Enter") return;
          event.preventDefault();
          event.stopPropagation();
          setValue("");
          onCode(value);
        }}
      />
    </div>
  );
}
